import axios from 'axios';
import { buildErrorMessage } from '@/helpers/httpErrorMessage';
import { message } from 'ant-design-vue';
import config from '@/config'; // eslint-disable-line import/extensions
import { isLaunchInProgressError } from '@/helpers/launchErrors';
import { isRenderRevisionChoiceError } from '@/helpers/renderRevisionChoice';

const showErrorMessage = (text) => {
  message.error({
    content: text,
    duration: 5,
  });
};

const isHandledByCaller = (error) => (error?.response?.status === 403 && error?.response?.data?.message)
  || isLaunchInProgressError(error)
  || isRenderRevisionChoiceError(error);

const handleResponseError = (error) => {
  if (error.config?.silent) throw error;

  if (isHandledByCaller(error)) {
    throw error;
  }

  const messageText = buildErrorMessage(error);

  if (messageText) {
    showErrorMessage(messageText);
  }

  if (error?.response?.status >= 500 && !error.config?.recoverable) {
    window.location.href = `/error?message=${encodeURIComponent(messageText)}`;
  }
  throw error;
};

export const createHttpClient = () => {
  const client = axios.create({
    baseURL: config.apiUrl,
    headers: { Accept: 'application/json' },
  });

  client.interceptors.response.use((response) => response, handleResponseError);

  return client;
};

export const httpClient = createHttpClient();

export const fileDownloadConfig = {
  headers: { Accept: '*' },
  responseType: 'blob',
};
